/**
 * Canonical audit changeCategory codes (mirrors services ChangeCategories).
 * Used for i18n keys: auditLogs.changeCategory.<code>
 */
export const AuditLogChangeCategories = {
  OrganizationCreate: 'organization_create',
  OrganizationUpdate: 'organization_update',
  OrganizationDelete: 'organization_delete',
  DivisionCreate: 'division_create',
  DivisionUpdate: 'division_update',
  DivisionDelete: 'division_delete',
  ScheduleCreate: 'schedule_create',
  ScheduleUpdate: 'schedule_update',
  ScheduleDelete: 'schedule_delete',
  ScheduleTemplateCreate: 'schedule_template_create',
  ScheduleTemplateUpdate: 'schedule_template_update',
  ScheduleTemplateDelete: 'schedule_template_delete',
  LocationCreate: 'location_create',
  LocationUpdate: 'location_update',
  LocationDelete: 'location_delete',
  LocationGroupCreate: 'location_group_create',
  LocationGroupUpdate: 'location_group_update',
  LocationGroupDelete: 'location_group_delete',
  AddressCreate: 'address_create',
  AddressUpdate: 'address_update',
  AddressDelete: 'address_delete',
  EventCreate: 'event_create',
  EventUpdate: 'event_update',
  EventDelete: 'event_delete',
  EventTypeCreate: 'event_type_create',
  EventTypeUpdate: 'event_type_update',
  EventTypeDelete: 'event_type_delete',
  OrganizationFormCreate: 'organization_form_create',
  OrganizationFormUpdate: 'organization_form_update',
  OrganizationFormDelete: 'organization_form_delete',
  TriggerCreate: 'trigger_create',
  TriggerUpdate: 'trigger_update',
  TriggerDelete: 'trigger_delete',
  GroupCreate: 'group_create',
  GroupUpdate: 'group_update',
  GroupDelete: 'group_delete',
  DashboardCreate: 'dashboard_create',
  DashboardUpdate: 'dashboard_update',
  DashboardDelete: 'dashboard_delete',
  DashboardTableCreate: 'dashboard_table_create',
  DashboardTableUpdate: 'dashboard_table_update',
  DashboardTableDelete: 'dashboard_table_delete',
  UserCreate: 'user_create',
  UserUpdate: 'user_update',
  UserDelete: 'user_delete',
  UserJobCreate: 'user_job_create',
  UserJobUpdate: 'user_job_update',
  UserJobDelete: 'user_job_delete',
  InvitationCreate: 'invitation_create',
  InvitationUpdate: 'invitation_update',
  InvitationDelete: 'invitation_delete',
  ExceptionCreate: 'exception_create',
  ExceptionUpdate: 'exception_update',
  ExceptionDelete: 'exception_delete',
  AttendanceRecordCreate: 'attendance_record_create',
  AttendanceRecordUpdate: 'attendance_record_update',
  AttendanceRecordDelete: 'attendance_record_delete',
  WorkJourneyCreate: 'work_journey_create',
  WorkJourneyUpdate: 'work_journey_update',
  WorkJourneyDelete: 'work_journey_delete',
  WorkJourneyConfigCreate: 'work_journey_config_create',
  WorkJourneyConfigUpdate: 'work_journey_config_update',
  WorkJourneyConfigDelete: 'work_journey_config_delete',
  WorkJourneyConfigMemberCreate: 'work_journey_config_member_create',
  WorkJourneyConfigMemberUpdate: 'work_journey_config_member_update',
  WorkJourneyConfigMemberDelete: 'work_journey_config_member_delete',
  WorkJourneyConfigMemberError: 'work_journey_config_member_error',
  WorkJourneyConfigSupervisorCreate: 'work_journey_config_supervisor_create',
  WorkJourneyConfigSupervisorUpdate: 'work_journey_config_supervisor_update',
  WorkJourneyConfigSupervisorDelete: 'work_journey_config_supervisor_delete',
  WorkShiftCreate: 'work_shift_create',
  WorkShiftUpdate: 'work_shift_update',
  WorkShiftDelete: 'work_shift_delete',
  CompanyCreate: 'company_create',
  CompanyUpdate: 'company_update',
  CompanyDelete: 'company_delete',
  ExecutionCreate: 'execution_create',
  ExecutionUpdate: 'execution_update',
  ExecutionDelete: 'execution_delete',
  NotificationSubscriberCreate: 'notification_subscriber_create',
  NotificationSubscriberUpdate: 'notification_subscriber_update',
  NotificationSubscriberDelete: 'notification_subscriber_delete',
  MonthlyOvertimeJobCreate: 'monthly_overtime_job_create',
  MonthlyOvertimeJobUpdate: 'monthly_overtime_job_update',
  MonthlyOvertimeJobDelete: 'monthly_overtime_job_delete',
  EmergencyCreate: 'emergency_create',
  EmergencyUpdate: 'emergency_update',
  EmergencyDelete: 'emergency_delete',
  WorkShiftPolicyCreate: 'work_shift_policy_create',
  WorkShiftPolicyUpdate: 'work_shift_policy_update',
  WorkShiftPolicyDelete: 'work_shift_policy_delete',
  HolidayCreate: 'holiday_create',
  HolidayUpdate: 'holiday_update',
  HolidayDelete: 'holiday_delete',
} as const;

export type AuditLogChangeCategory =
  typeof AuditLogChangeCategories[keyof typeof AuditLogChangeCategories];

export const AUDIT_LOG_CHANGE_CATEGORY_VALUES: AuditLogChangeCategory[] =
  Object.values(AuditLogChangeCategories);

export const isAuditLogChangeCategory = (
  value: string,
): value is AuditLogChangeCategory => {
  return (AUDIT_LOG_CHANGE_CATEGORY_VALUES as string[]).includes(value);
};

export const getAuditLogChangeCategoryMessageId = (
  changeCategory: string,
): string => `auditLogs.changeCategory.${changeCategory}`;
